import { render, staticRenderFns } from "./EmailList.vue?vue&type=template&id=47bd4d3c&scoped=true"
import script from "./EmailList.vue?vue&type=script&lang=js"
export * from "./EmailList.vue?vue&type=script&lang=js"
import style0 from "./EmailList.vue?vue&type=style&index=0&id=47bd4d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bd4d3c",
  null
  
)

export default component.exports